// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { CalendarScheduleIcon } from '@moia-dev/pace-icons'
import { HulkTripsAreaRoutes } from './HulkTripsAreaRoutes'

export const HulkTripsAreaNavigationIcon = CalendarScheduleIcon

export const HulkTripsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={HulkTripsAreaRoutes.route}
      Icon={CalendarScheduleIcon}
    />
  )
}
